import { AppState, Auth0Provider } from '@auth0/auth0-react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { ConnectedRouter } from 'connected-react-router';
import Gleap from 'gleap';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Root } from './components/Root';
import { theme } from './components/theme';
import ErrorBoundary from './components/utility/ErrorBoundary';
import { auth } from './config';
import './index.css';
import { configureStore, getHistory } from './state';

const store = configureStore();
const history = getHistory();

Gleap.initialize('NnxhPfhh9yq1Yid96Rl0DWoVYWAgijXF');

const handleRedirectCallback = (appState: AppState) => {
  const { returnTo } = appState;
  if (returnTo) {
    history.push(returnTo);
  }
};

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ConnectedRouter history={history}>
        <ErrorBoundary>
          <Auth0Provider
            domain={auth.domain}
            clientId={auth.clientID}
            authorizationParams={{
              redirect_uri: auth.redirectUri,
              audience: auth.audience,
              scope: auth.scope,
            }}
            onRedirectCallback={(appState?: AppState) => {
              handleRedirectCallback(appState as AppState);
            }}
          >
            <Root />
          </Auth0Provider>
        </ErrorBoundary>
      </ConnectedRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root') as HTMLElement
);
